/** Rows the verification table can actually show: a status plus a message. */

const LABELS = {
  concrete_stress: 'Concrete stress',
  tendon_service: 'Tendon service',
  tendon_transfer: 'Tendon transfer',
  rebar_y: 'Rebar A_s,y',
  rebar_x: 'Rebar A_s,x',
  composite: 'Composite M_Rd',
  interface_shear: 'Interface v_Edi',
  quasi_permanent_compression: 'Quasi-permanent compression',
};

function isCheck(value) {
  return value && typeof value.ok === 'boolean' && typeof value.message === 'string' && value.message;
}

export function slabVerificationRows(verifications) {
  const rows = [];
  if (!verifications) return rows;
  Object.entries(verifications).forEach(([key, value]) => {
    if (key === 'combination' || key === 'prestress_losses') return;
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (!isCheck(item)) return;
        const edge = item.edge ? ` ${item.edge}` : '';
        rows.push({
          key: `${key}-${item.edge || index}`,
          label: `Support shear${edge}`,
          ok: item.ok,
          message: item.message,
        });
      });
      return;
    }
    if (!isCheck(value)) return;
    rows.push({
      key,
      label: LABELS[key] || key,
      ok: value.ok,
      message: value.message,
    });
  });
  return rows;
}

export function slabVerificationNotes(verifications) {
  const notes = [];
  if (!verifications) return notes;
  if (typeof verifications.combination === 'string' && verifications.combination) {
    notes.push(`Governing ULS combination ${verifications.combination}`);
  }
  if (typeof verifications.prestress_losses === 'string' && verifications.prestress_losses) {
    notes.push(verifications.prestress_losses);
  }
  return notes;
}
